import { render, staticRenderFns } from "./UpdateOrderStatusDialog.vue?vue&type=template&id=2457edc0"
import script from "./UpdateOrderStatusDialog.vue?vue&type=script&lang=js"
export * from "./UpdateOrderStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports